<template>
    <span
        class="tab"
        @click="$emit('changeLayout', type)"
        :class="{
            'tab_active': layout === type
        }"
    >
        {{text}}
    </span>
</template>

<script>
export default {
    props: {
        type: {
            required: true,
        },
        layout: {
            required: true,
        },
        text: {
            required: true,
        },
    },

}
</script>
